// Service pour gérer l'accès au contenu basé sur les dates
export const calculatePhaseAccess = (startDate) => {
  const today = new Date();
  const start = new Date(startDate);
  
  // Calculer le nombre de jours depuis le début
  const timeDiff = today.getTime() - start.getTime();
  const daysDiff = Math.floor(timeDiff / (1000 * 3600 * 24));
  
  // Définir les règles d'accès aux phases et jours
  const phaseRules = [
    {
      phaseIndex: 0, // Baseline Assessment
      accessibleFrom: -1, // Accessible 1 jour avant le début
      accessibleUntil: 0,   // Accessible jusqu'au jour 0
      days: [
        { dayNumber: -1, accessibleFrom: -1, accessibleUntil: 0 }
      ]
    },
    {
      phaseIndex: 1, // Buchinger Fasting Phase
      accessibleFrom: 1,  // Accessible à partir du jour 1
      accessibleUntil: 5,  // Accessible jusqu'au jour 5
      days: [
        { dayNumber: 1, accessibleFrom: 1, accessibleUntil: 1 },
        { dayNumber: 2, accessibleFrom: 2, accessibleUntil: 2 },
        { dayNumber: 3, accessibleFrom: 3, accessibleUntil: 3 },
        { dayNumber: 4, accessibleFrom: 4, accessibleUntil: 4 },
        { dayNumber: 5, accessibleFrom: 5, accessibleUntil: 5 }
      ]
    },
    {
      phaseIndex: 2, // Intermittent Fasting Support
      accessibleFrom: 6,  // Accessible à partir du jour 6
      accessibleUntil: 11, // Accessible jusqu'au jour 11
      days: [
        { dayNumber: 6, accessibleFrom: 6, accessibleUntil: 6 },
        { dayNumber: 7, accessibleFrom: 7, accessibleUntil: 7 },
        { dayNumber: 8, accessibleFrom: 8, accessibleUntil: 8 },
        { dayNumber: 9, accessibleFrom: 9, accessibleUntil: 9 },
        { dayNumber: 10, accessibleFrom: 10, accessibleUntil: 10 },
        { dayNumber: 11, accessibleFrom: 11, accessibleUntil: 11 }
      ]
    },

  ];
  
  // Déterminer quelle phase et quel jour sont actuellement accessibles
  let currentPhase = -1;
  let currentDay = null;
  let accessiblePhases = [];
  let accessibleDays = {};
  
  phaseRules.forEach((rule, phaseIndex) => {
    if (daysDiff >= rule.accessibleFrom && daysDiff <= rule.accessibleUntil) {
      currentPhase = phaseIndex;
    }
    if (daysDiff >= rule.accessibleFrom) {
      accessiblePhases.push(phaseIndex);
      
      // Déterminer les jours accessibles dans cette phase
      accessibleDays[phaseIndex] = [];
      rule.days.forEach(dayRule => {
        if (daysDiff >= dayRule.accessibleFrom && daysDiff <= dayRule.accessibleUntil) {
          currentDay = { phaseIndex, dayNumber: dayRule.dayNumber };
        }
        if (daysDiff >= dayRule.accessibleFrom) {
          accessibleDays[phaseIndex].push(dayRule.dayNumber);
        }
      });
    }
  });
  
  return {
    currentPhase,
    currentDay,
    accessiblePhases,
    accessibleDays,
    daysSinceStart: daysDiff,
    isBeforeStart: daysDiff < 0,
    isAfterProtocol: daysDiff > 11
  };
};

export const getPhaseStatus = (phaseIndex, accessiblePhases, currentPhase) => {
  if (phaseIndex < Math.min(...accessiblePhases)) {
    return 'locked';
  } else if (phaseIndex === currentPhase) {
    return 'current';
  } else if (phaseIndex <= Math.max(...accessiblePhases)) {
    return 'completed';
  } else {
    return 'locked';
  }
};

export const getDayStatus = (dayNumber, phaseIndex, accessibleDays, currentDay) => {
  if (!accessibleDays[phaseIndex] || !accessibleDays[phaseIndex].includes(dayNumber)) {
    return 'locked';
  } else if (currentDay && currentDay.phaseIndex === phaseIndex && currentDay.dayNumber === dayNumber) {
    return 'current';
  } else {
    return 'completed';
  }
};

export const formatDate = (dateString, language = 'en') => {
  const date = new Date(dateString);
  return date.toLocaleDateString(language === 'de' ? 'de-DE' : 'en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });
};

export const getDaysUntilStart = (startDate) => {
  const today = new Date();
  const start = new Date(startDate + 'T00:00:00.000Z');
  
  // Normaliser les dates à minuit pour comparer les jours calendaires
  const todayNormalized = new Date(today.getFullYear(), today.getMonth(), today.getDate());
  const startNormalized = new Date(start.getFullYear(), start.getMonth(), start.getDate());
  
  const timeDiff = startNormalized.getTime() - todayNormalized.getTime();
  return Math.ceil(timeDiff / (1000 * 3600 * 24));
};

export const getDaysSinceStart = (startDate) => {
  const today = new Date();
  const start = new Date(startDate + 'T00:00:00.000Z');
  
  // Normaliser les dates à minuit pour comparer les jours calendaires
  const todayNormalized = new Date(today.getFullYear(), today.getMonth(), today.getDate());
  const startNormalized = new Date(start.getFullYear(), start.getMonth(), start.getDate());
  
  const timeDiff = todayNormalized.getTime() - startNormalized.getTime();
  return Math.floor(timeDiff / (1000 * 3600 * 24));
}; 

// Service pour gérer les dates locales
export const getLocalISOString = () => {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, '0');
  const day = String(now.getDate()).padStart(2, '0');
  const hours = String(now.getHours()).padStart(2, '0');
  const minutes = String(now.getMinutes()).padStart(2, '0');
  const seconds = String(now.getSeconds()).padStart(2, '0');
  const milliseconds = String(now.getMilliseconds()).padStart(3, '0');
  
  return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}.${milliseconds}Z`;
}; 